let interactedWith = false;

function audioUnlock(audioContext, callback) {
  // Instantiate an audioContext if one wasn't passed
  if (!audioContext) {
    const AudioContext = window.AudioContext || window.webkitAudioContext;

    audioContext = false;

    if (AudioContext) {
      audioContext = new AudioContext();
    }
  }

  // Exit early if context is not suspended
  if (audioContext.state !== 'suspended') {
    if (typeof callback === 'function') {
      callback(audioContext);
    }

    return;
  }

  const unlockEvents = ['touchstart', 'touchend', 'mousedown', 'keydown'];

  // Resume audioContext on first user interaction
  // (audioContext is often suspended by default)
  const onFirstInteraction = () => {
    audioContext.resume().then(() => {
      // Early return if 'resume' callback has already run
      if (interactedWith) return;

      // Track the first time this runs to avoid a second run
      interactedWith = true;

      if (typeof callback === 'function') {
        callback(audioContext);
      }

      // Only need to do this once, so remove listeners
      unlockEvents.forEach((unlockEvent) => {
        document.removeEventListener(unlockEvent, onFirstInteraction);
      });
    });
  };

  // Listen for first interaction
  unlockEvents.forEach((unlockEvent) => {
    document.addEventListener(unlockEvent, onFirstInteraction);
  });

  return audioContext;
}

export default audioUnlock;
